/* eslint-disable */
import React, { useState } from 'react'
import styled from '@emotion/styled'
import { any, bool, func, string } from 'prop-types'
import Loader from 'components/loader'

const LoaderWrapper = styled.span`
  padding-left: 4px;
`

const RouteButton = styled.button`
  background-color: ${({ theme, disabled }) =>
    !disabled ? theme.colors.primary : '#C0C0C0'};
  color: white;
  height: 40px;
  padding-left: 24px;
  padding-right: 24px;
  border-radius: 999em;
  border: none;
  cursor: pointer;
  font-size: 18px;
  font-family: 'Titillium Web';
  outline: 1px solid transparent;
`

const Button = ({ children, onClick, disabled, ...props }) => {
  const [loading, setLoading] = useState(false)
  return (
    <RouteButton
      type="button"
      disabled={disabled || loading}
      onClick={(e) => {
        if (!loading) {
          const val = onClick(e)
          const isPromise = val instanceof Promise
          if (isPromise) {
            setLoading(true)

            return val.then((res) => {
              setLoading(false)
              return res
            })
          }
          return val
        }
        return null
      }}
      {...props}>
      {children}

      {loading ? (
        <LoaderWrapper>
          <Loader height={18} width={18} />
        </LoaderWrapper>
      ) : null}
    </RouteButton>
  )
}

Button.propTypes = {
  children: any,
  disabled: bool,
  onClick: func,
}

Button.defaultProps = {
  children: null,
  disabled: false,
  onClick: () => {},
}

export default Button
